(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sp-product-page-tools"] && !Shopify.designMode) return;
  try {
    (function () {
    function initShare() {
      var share = document.querySelector('[data-sp-share]:not([data-initialized])');
      if (!share) return;
      share.dataset.initialized = 'true';

      /* Place the row right under the Add to cart buttons. */
      var main = document.getElementById('MainContent') || document;
      var anchor =
        main.querySelector('.buy-buttons-block') ||
        main.querySelector('product-form-component') ||
        main.querySelector('form[action*="/cart/add"]');
      if (anchor) {
        anchor.insertAdjacentElement('afterend', share);
      } else {
        share.classList.add('is-floating');
      }

      var url = share.dataset.url || window.location.href;
      var title = share.dataset.title || document.title;
      var toast = share.querySelector('[data-sp-share-toast]');
      var toastTimer;

      var isPhone = !!navigator.share && window.matchMedia('(pointer: coarse)').matches;
      share.classList.toggle('is-native', isPhone);
      share.hidden = false;

      function say(message) {
        if (!toast) return;
        toast.textContent = message;
        toast.classList.add('is-visible');
        window.clearTimeout(toastTimer);
        toastTimer = window.setTimeout(function () { toast.classList.remove('is-visible'); }, 2600);
      }

      function copyLink() {
        if (navigator.clipboard && window.isSecureContext) {
          return navigator.clipboard.writeText(url);
        }
        var input = document.createElement('textarea');
        input.value = url;
        input.setAttribute('readonly', '');
        input.style.position = 'fixed';
        input.style.opacity = '0';
        document.body.appendChild(input);
        input.select();
        document.execCommand('copy');
        input.remove();
        return Promise.resolve();
      }

      var nativeBtn = share.querySelector('[data-sp-share-native]');
      if (nativeBtn) {
        nativeBtn.addEventListener('click', function () {
          if (navigator.share) {
            navigator.share({ title: title, url: url }).catch(function () {});
          } else {
            copyLink().then(function () { say('Link copied'); });
          }
        });
      }

      var copyBtn = share.querySelector('[data-sp-share-copy]');
      if (copyBtn) {
        copyBtn.addEventListener('click', function () {
          copyLink().then(function () { say('Link copied'); }, function () { say(url); });
        });
      }

      var igBtn = share.querySelector('[data-sp-share-ig]');
      if (igBtn) {
        igBtn.addEventListener('click', function () {
          /* Instagram has no web share link: copy the product link, then open Instagram DMs in a new tab
             (opened inside the click so pop-up blockers allow it). */
          window.open('https://www.instagram.com/direct/inbox/', '_blank', 'noopener');
          copyLink().then(
            function () { say('Link copied — paste it in the Instagram DM'); },
            function () { say(url); }
          );
        });
      }
    }

    function initTop() {
      document.querySelectorAll('[data-sp-product-tools]:not([data-initialized])').forEach(function (tools) {
        tools.dataset.initialized = 'true';
        var scrollButton = tools.querySelector('[data-sp-scroll-top]');
        var pageScroller = document.querySelector('.page-wrapper');
        var documentScroller = document.scrollingElement || document.documentElement;
        var ticking = false;

        if (scrollButton) {
          scrollButton.addEventListener('click', function () {
            var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            var behavior = reduceMotion ? 'auto' : 'smooth';
            if (pageScroller) pageScroller.scrollTo({ top: 0, behavior: behavior });
            window.scrollTo({ top: 0, behavior: behavior });
          });
        }

        function update() {
          var scrollTop = Math.max(
            window.scrollY,
            pageScroller ? pageScroller.scrollTop : 0,
            documentScroller.scrollTop,
            document.body.scrollTop
          );
          if (scrollButton) scrollButton.classList.toggle('is-visible', scrollTop > 180);
          ticking = false;
        }

        function onScroll() {
          if (!ticking) {
            window.requestAnimationFrame(update);
            ticking = true;
          }
        }

        window.addEventListener('scroll', onScroll, { passive: true });
        if (pageScroller) pageScroller.addEventListener('scroll', onScroll, { passive: true });
        update();
      });
    }

    function init() {
      initShare();
      initTop();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
